"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingClass = void 0;
exports.ReportingClass = {
    getBanners: 'BannersApi.getBanners',
};
//# sourceMappingURL=constants.js.map